import * as React from "react"

export function useTimeAgo(timestamp: number | null) {
  return React.useMemo(() => {
    if (!timestamp) return
    const date = new Date(timestamp)
    const now = new Date()
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1_000)
    const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })

    const minute = 60
    const hour = minute * 60
    if (diffInSeconds < hour)
      return date.toLocaleTimeString(undefined, {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
      })

    const day = hour * 24
    if (diffInSeconds < day)
      return rtf.format(-Math.floor(diffInSeconds / hour), "hour")

    const month = day * 30
    if (diffInSeconds < month)
      return rtf.format(-Math.floor(diffInSeconds / day), "day")

    const year = day * 365
    if (diffInSeconds < year)
      return rtf.format(-Math.floor(diffInSeconds / month), "month")

    return rtf.format(-Math.floor(diffInSeconds / year), "year")
  }, [timestamp])
}
